import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tent, Laugh, CalendarDays, Handshake, BadgePercent } from 'lucide-react';
import { motion } from 'framer-motion';

const items = [
  { id: 'jatra', title: 'Jatra', icon: 'mobile/icons/jatra.png', path: '/shows' },
  { id: 'gananatya', title: 'Gananatya', icon: 'mobile/icons/ganatya.png', path: '/gananatya' },
  {
    id: 'camps',
    title: 'Camps',
    lucideIcon: <Tent size={22} className="text-emerald-600" />,
    path: '/camps'
  },
  { id: 'actors', title: 'Actors', icon: 'mobile/icons/actors.png', path: '/shows' },
  { id: 'ticket', title: 'Ticket', icon: 'mobile/icons/ticket.png', path: '/my-tickets' },
  { id: 'orchestra', title: 'Orchestra', icon: 'mobile/icons/orchestra.png', path: '/shows' },
  { id: 'dance', title: 'Dance', icon: 'mobile/icons/dance.png', path: '/shows' },
  {
    id: 'partner',
    title: 'Partner',
    lucideIcon: <Handshake size={22} className="text-[#9333ea]" />,
    path: '/shows'
  },
  {
    id: 'comedy',
    title: 'Comedy',
    lucideIcon: <Laugh size={22} className="text-[#f59e0b]" />,
    path: '/shows'
  },
  {
    id: 'upcoming',
    title: 'Upcoming',
    lucideIcon: <CalendarDays size={22} className="text-[#2563eb]" />,
    path: '/shows'
  },
  {
    id: 'offers',
    title: 'Offers',
    lucideIcon: <BadgePercent size={22} className="text-[#f43f5e]" />,
    path: '/shows'
  },
  { id: 'seemore', title: 'SeeMore', icon: 'mobile/icons/seemore.png', path: '/shows' },
];

export default function Categories() {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.03 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 8, scale: 0.92 },
    show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.25, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <div className="w-full bg-white py-1 md:pb-2.5">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="flex items-center justify-between gap-3 sm:gap-4 md:gap-5 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] py-1 px-0.5"
        >
          {items.map((item) => (
            <motion.div
              variants={itemVariants}
              key={item.id}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center group cursor-pointer shrink-0 py-0.5 px-0.5"
            >
              {/* Circular container */}
              <div className="w-12 h-12 sm:w-13 sm:h-13 md:w-12 md:h-12 rounded-full flex items-center justify-center p-1 bg-white border border-gray-200/90 shadow-sm group-hover:shadow-md group-hover:border-red-400 group-hover:scale-105 active:scale-95 transition-all duration-200">
                {item.icon ? (
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="w-7 h-7 md:w-7 md:h-7 object-contain transition-transform duration-200 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-7 h-7 md:w-7 md:h-7 flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
                    {item.lucideIcon}
                  </div>
                )}
              </div>

              {/* Title label */}
              <span className="mt-1 text-[10px] sm:text-[11px] font-medium text-gray-700 group-hover:text-red-600 transition-colors text-center tracking-tight truncate max-w-[65px]">
                {item.title}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
